import { render, staticRenderFns } from "./DifferentTransOptions.vue?vue&type=template&id=0243d315"
import script from "./DifferentTransOptions.vue?vue&type=script&lang=js"
export * from "./DifferentTransOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports